
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { HUB_PAGE } from '@/components/transcription-landing/landingPages';
import TranscriptionLanding from '@/components/transcription-landing/TranscriptionLanding';
export default function AiTranscriptionPage() {
    return <TranscriptionLanding page={HUB_PAGE}/>;
}

    async function __Next_Translate__getStaticProps__1a13a29a18c__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/ai-transcription/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a13a29a18c__ as getStaticProps }
  